module.exports = __webpack_public_path__ + "static/media/pago1.7420e05f.svg";